import { styled } from '@mui/material';

import { HeadingLarge } from '@itp/talent/components/core/typography';

export const AuthHeading = styled(HeadingLarge)(({ theme }) => ({
  color: theme.palette.secondary.main,
  textAlign: 'center',
}));
